import React from "react";
import Banner from "../components/banner";
import ErrorComponent from "../components/partnerError";

import DonationHistory from "../components/donationHistory";
import { Table, Alert, Button, Loader } from "kepler";

const bodyTagData = $("body").data();

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      charityName: bodyTagData.charityname || "",
      errorType: bodyTagData.body.errorType
    };
  }

  render() {
    const errorType = this.state.errorType;
    if (!errorType) {
      return (
        <div>
          <Banner charityName={this.state.charityName} pageName={bodyTagData.body.pageName}/>
          <div className="container">
            <div id="donationWrapper" className="dashboardContainer">
              <DonationHistory
                donationData={bodyTagData}
                charityName={this.state.charityName}
              />
            </div>
          </div>
        </div>
      );
    } else {
        return (<div><ErrorComponent errorType={errorType}/></div>);
    }
  }
}



// WEBPACK FOOTER //
// ./partner/components/dashboard.js